import { createRouter, createWebHistory } from "vue-router";

const Home = () => import(/* webpackChunkName: "home" */ "../pages/Home.vue");
const FAQ = () => import(/* webpackChunkName: "faq" */ "../pages/FAQ.vue");
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "../pages/Dashboard.vue");
const MyAnalyses = () =>
  import(/* webpackChunkName: "my-analyses" */ "../pages/MyAnalyses.vue");
const Selection = () =>
  import(/* webpackChunkName: "selection" */ "../pages/Selection.vue");
const Disclaimer = () =>
  import(/* webpackChunkName: "disclaimer" */ "../pages/Disclaimer.vue");
const CookiesPrivacy = () =>
  import(
    /* webpackChunkName: "cookies-privacy" */ "../pages/Cookies_Privacy.vue"
  );
const Contact = () =>
  import(/* webpackChunkName: "contact" */ "../pages/Contact.vue");
const LoadingResults = () =>
  import(/* webpackChunkName: "loading-results" */ "../pages/LoadingResults");
const Profiel = () =>
  import(/* webpackChunkName: "profile" */ "../pages/Profiel.vue");
const CaseStudies = () =>
  import(/* webpackChunkName : "case-studies" */ "../pages/CaseStudies.vue");

// SelectPages
const DemographySelections = () =>
  import(
    /* webpackChunkName: "demography" */ "../pages/Selections/Demography.vue"
  );
const MainSelections = () =>
  import(/* webpackChunkName: "main" */ "../pages/Selections/Main.vue");
const MentalitySelections = () =>
  import(
    /* webpackChunkName: "mentality" */ "../pages/Selections/Mentality.vue"
  );
const FintalitySelections = () =>
  import(
    /* webpackChunkName: "fintality" */ "../pages/Selections/Fintality.vue"
  );
const BurgerschapsstijlenSelections = () =>
  import(
    /* webpackChunkName: "Burgerschapsstijlen" */ "../pages/Selections/Burgerschapsstijlen.vue"
  );
const ShopperMentalitySelections = () =>
  import(
    /* webpackChunkName: "ShopperMentality" */ "../pages/Selections/ShopperMentality.vue"
  );
const VitalitySelections = () =>
  import(/* webpackChunkName: "Vitality" */ "../pages/Selections/Vitality.vue");
const ZorgMentalitySelections = () =>
  import(
    /* webpackChunkName: "ZorgMentality" */ "../pages/Selections/ZorgMentality.vue"
  );
const VijfTintenGroenerSelections = () =>
  import(
    /* webpackChunkName: "VijfTintenGroener" */ "../pages/Selections/VijfTintenGroener.vue"
  );
const VrijetijdsprofielenSelections = () =>
  import(
    /* webpackChunkName: "Vrijetijdsprofielen" */ "../pages/Selections/Vrijetijdsprofielen.vue"
  );

const GeneralSelection = () =>
  import(
    /* webpackChunkName: "general-selection" */ "../pages/Selections/GeneralSelection.vue"
  );
const AssignName = () =>
  import(/* webpackChunkName: "assign-name" */ "../pages/AssignName.vue");

/* Result pages */
const MainResults = () =>
  import(/* webpackChunkName: "main" */ "../pages/Results/Main.vue");
const GeneralResults = () =>
  import(
    /* webchunkName: general-results" */ "../pages/Results/GeneralResults.vue"
  );
const Results = () =>
  import(/* webpackChunkName: "Result" */ "../pages/Results.vue");

const routes = [
  { path: "/", component: Home, props: true },
  { path: "/faq", component: FAQ, props: true },
  { path: "/dashboard", component: Dashboard, props: true },
  { path: "/my-analyses", component: MyAnalyses, props: true },
  { path: "/disclaimer", component: Disclaimer, props: true },
  { path: "/cookies-privacy", component: CookiesPrivacy, props: true },
  { path: "/contact", component: Contact, props: true },
  { path: "/laden-resultaat", component: LoadingResults, props: true },
  { path: "/profiel", component: Profiel, props: true },
  { path: "/case-studies", component: CaseStudies, props: true },
  {
    path: "/selectie",
    component: Selection,
    props: true,
    children: [
      {
        path: "",
        name: "mainSelection",
        component: MainSelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "selectie" },
          ],
        },
      },
      {
        path: "geefnaam",
        name: "AssignName",
        component: AssignName,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
            { name: "Geef naam", link: "/selectie/geefnaam" },
          ],
        },
      },
      {
        path: "mentality",
        name: "mentality",
        component: MentalitySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "fintality",
        name: "fintality",
        component: FintalitySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "burgerschapsstijlen",
        name: "burgerschapsstijlen",
        component: BurgerschapsstijlenSelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "shopperMentality",
        name: "shopperMentality",
        component: ShopperMentalitySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "vitality",
        name: "vitality",
        component: VitalitySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "zorgMentality",
        name: "zorgMentality",
        component: ZorgMentalitySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "vijfTintenGroener",
        name: "vijfTintenGroener",
        component: VijfTintenGroenerSelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "vrijetijdsprofielen",
        name: "vrijetijdsprofielen",
        component: VrijetijdsprofielenSelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: "demografie",
        name: "demography",
        component: DemographySelections,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
      },
      {
        path: ":page",
        name: "generalSelection",
        component: GeneralSelection,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
          ],
        },
        props: (route) => ({ query: route.query.q }),
      },
    ],
  },
  {
    path: "/resultaat",
    component: Results,
    props: true,
    children: [
      {
        path: "",
        name: "mainResults",
        component: MainResults,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
            { name: "Geef-naam", link: "/selectie/geefnaam" },
            { name: "Resultaat", link: "/resultaat" },
          ],
        },
      },
      {
        path: ":page",
        name: "generalResults",
        component: GeneralResults,
        meta: {
          breadcrumb: [
            { name: "Begin", link: "/dashboard" },
            { name: "Selectie", link: "/selectie" },
            { name: "Geef-naam", link: "/selectie/geefnaam" },
            { name: "Resultaat", link: "/resultaat" },
          ],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  //  Redirect to Homepage if not logged in and trying to access a restricted page
  const publicpages = [
    "/",
    "/faq",
    "/case-studies",
    "/disclaimer",
    "/contact",
    "/cookies-privacy",
    "/no-access",
  ];
  const authRequired = !publicpages.includes(to.path);
  const loggedIn = localStorage.getItem("token");

  if (authRequired && !loggedIn) {
    return next("/");
  }
  next();
});

export default router;

// export const linkimg = 'http://10.0.0.119:8054/data/'
// export const linkimg = 'http://85.17.215.243/womapi/data/'
export const linkimg = "https://www.motivactionprofiler.nl/womapi/data/";
